import Image from 'next/image'
import { Button, Col, Container, Row } from '@microfrontends/react-components'
import { About, AboutWrap, Box, CustomIframe } from '../Numerology.css'
import Title from '../../../components/NumerologyV2/Title'
import { PythagoImage } from '../../../components/NumerologyV2/PythagoImage'
import { useContext } from 'react'
import AppContext from '../../../context/AppContext'
import { EDevice } from '../../MainLayout'
import { Paragraph } from '../../../components/NumerologyV2/index.css'

interface IProps {
	handleOpen?: () => void
}
const imgBaseUrl = process.env.IMAGE_BASE_URL
export default function AboutNumerology({ handleOpen }: IProps) {
	const { breakpoint, t } = useContext(AppContext)
	return (
		<AboutWrap>
			<Container>
				<About align='middle' justify='center' gutter={20}>
					<Col md={6} sm={10} xs={24}>
						<PythagoImage />
					</Col>
					<Col md={18} sm={14} xs={24}>
						<Box>
							<Title
								title='Nhân số học là gì?'
								marker='triangle'
								backgound='oval'
							/>
						</Box>
						<Paragraph
							style={{
								paddingLeft:
									breakpoint !== EDevice.MOBILE ? 50 : 0,
								marginBottom: 0
							}}
						>
							<b>
								Nhân số học (Numerology, hay còn gọi là Thần số
								học)
							</b>{' '}
							là bộ môn do nhà toán học Pythagoras đã nghiên cứu
							và phát triển từ khoảng 2.600 năm trước. Nhân số học
							ngày này được rất nhiều bạn trẻ biết đến & sử dụng,
							giúp bạn có cái nhìn tham khảo để tìm hiểu thêm về
							thế mạnh của bản thân, qua đó tìm ra định hướng trên
							hành trình phát triển sự nghiệp.
						</Paragraph>
					</Col>
				</About>
			</Container>
			<Container>
				<About align='middle' gutter={20} className='row-reverse'>
					<Col md={9} sm={10}>
						<Box>
							<Title
								title='Khám phá thêm về Nhân số học'
								marker='star'
								backgound='arrow'
							/>
							<CustomIframe
								width={'100%'}
								height={'100%'}
								src='https://www.youtube.com/embed/VtM8Rvqq-ic'
								title='Khám phá thêm về Nhân số học'
								frameBorder={0}
								allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
								allowFullScreen
							/>
							{breakpoint !== EDevice.MOBILE ? (
								<Box className='center'>
									<Button
										type='primary'
										className='search_button center'
										onClick={handleOpen}
										style={{ marginTop: 20 }}
									>
										{t('Tra cứu nhân số học')}
									</Button>
								</Box>
							) : null}
						</Box>
					</Col>
					<Col md={15} sm={14}>
						<Paragraph>
							<b>Nhân số học (hay Thần số học)</b> chính là công
							cụ tham khảo nhằm giúp bạn gợi ý nghề nghiệp phù hợp
							dựa trên những điểm mạnh và điểm yếu của những con
							số liên quan đến bạn. Dựa trên thông tin: Họ tên,
							ngày tháng năm sinh của bạn, Nhân số học sẽ phân
							tích và tạo lập cho bạn biểu đồ sự nghiệp hoàn
							chỉnh.
						</Paragraph>
						<Paragraph style={{ marginBottom: 0 }}>
							Hãy trải nghiệm công cụ Nhân số học được phát minh
							bởi nhà toán học Pythagoras trên VietnamWorks để
							tham khảo, rồi tự soi chiếu lại xem những gì mình
							nhận thấy từ mình có khớp với kết quả không? Để từ
							đó, bạn khám phá tính năng Career Path - Lộ trình
							phát triển sự nghiệp của đa ngành giúp tìm kiếm công
							việc phù hợp được Nhân số học gợi ý nhé!
						</Paragraph>
					</Col>
				</About>
			</Container>
		</AboutWrap>
	)
}
